//sipariş ilk geldiğinde fraud kontrol sebebiyle sevkiyatlar oluşmadığı için gelen siparişin bilgilerinin gösterileceği component
import {
  Grid,
  Link,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Tooltip,
} from "@mui/material";
import { useEffect, useState } from "react";
import ProductCommand from "../../../../../services/command/product/productCommand.services";
import { useTranslation } from "react-i18next";
import { UOF } from "../userOrderProductDetails.classes";

function UserShowProductOnFraudControl({ data }: any) {
  const { t } = useTranslation();
  const saleOrderItemDatas = data.saleOrderItemForBackofficeModels;
  const [productData, setProductData] = useState<any>();

  useEffect(() => {
    let productIds = saleOrderItemDatas.map((item: any) => {
      return item.productId;
    });
    let req = { productIds: productIds };
    ProductCommand.GetProductDetailByProductIdList(req).then((res: any) => {
      if (res?.productInfos && res.productInfos.length > 0) {
        setProductData(res.productInfos);
      }
    });
  }, []);

  return (
    <div
      className={UOF.root}
      style={{
        padding: "2rem",
        marginTop: "2rem",
        backgroundColor: "#FAEBB6",
        boxShadow:
          "0px -4px 6px rgba(0, 0, 0, 0.1), 0px 4px 6px rgba(0, 0, 0, 0.1)",
      }}
    >
      {productData && productData.length > 0 && (
        <>
          <Table className={UOF.table}>
            <TableHead>
              <TableRow className={UOF.tableHeadRow}>
                <TableCell className={UOF.photoCell}>{t("orderDetail.photo")}</TableCell>
                <TableCell className={UOF.barcodeCell}>{t("orderDetail.product")}</TableCell>
                <TableCell align="center">
                  {t("orderDetail.quantity")}
                </TableCell>
                <TableCell align="center">{t("orderDetail.price")}</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {productData.map((row: any, index: number) => (
                <TableRow className={UOF.tableBodyRow} key={index}>
                  <TableCell align="left" className={UOF.photoCell}>
                    <div>
                      <img
                        src={row.productImageUrl}
                        alt={row.marka}
                        style={{ width: "90px", height: "auto" }}
                      />{" "}
                    </div>
                  </TableCell>
                  <div>
                    <Grid>
                      <p style={{ color: "red" }}>{row.brandName}</p>
                    </Grid>
                    <Grid>{row.productDescriptionOnWebSite}</Grid>
                    <Tooltip title={t("orderDetail.barcode")} placement="left">
                      <Grid>
                        <strong>{row.barcode}</strong>
                      </Grid>
                    </Tooltip>
                    <Tooltip
                      title={t("orderDetail.specialAndColorCode")}
                      placement="left"
                    >
                      <Grid>
                        <Link
                          className={UOF.optionLink}
                          target="_blank"
                          href={"/productDetail/" + row.optionId}
                        >
                          {row.ozelKod1} - {row.renkKod}
                        </Link>
                      </Grid>
                    </Tooltip>
                    <Tooltip title={"OptionId"} placement="left">
                      <Grid>{row.optionId}</Grid>
                    </Tooltip>
                    <Tooltip
                      title={t("general.color") + " - " + t("orderDetail.size")}
                      placement="left"
                    >
                      <Grid>{row.optionTitle + " - " + row.size}</Grid>
                    </Tooltip>
                  </div>
                  <TableCell align="center">
                    {
                      saleOrderItemDatas.find(
                        (item: any) => item.productId === row.productId
                      ).quantity
                    }
                  </TableCell>
                  <TableCell align="center">
                    {
                      saleOrderItemDatas.find(
                        (item: any) => item.productId === row.productId
                      ).cashPrice
                    }
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </>
      )}
    </div>
  );
}

export default UserShowProductOnFraudControl;
